module.exports = __webpack_public_path__ + "assets1779866876160/img/home-img.ff28be9e.jpg";